import { BellRing, Gift, X } from 'lucide-react';

import type { OptInGranted } from '../types';

type Props = {
  granted: OptInGranted | null;
  onClose: () => void;
  /** O que o cliente vai receber agora que ativou. */
  message: string;
  compact?: boolean;
};

/**
 * PRAT-43 — confirmação de quem acabou de ativar. Com cupom ativo na loja, o
 * código aparece na hora e já fica guardado para o próximo pedido; sem cupom,
 * só confirma.
 */
export function PushGrantedNote({ granted, onClose, message, compact }: Props) {
  const coupon = granted?.code ? granted : null;
  const details = coupon
    ? [
        coupon.availability_label ? `Vale ${coupon.availability_label}` : '',
        coupon.expiry_date
          ? `até ${new Date(`${coupon.expiry_date}T12:00:00`).toLocaleDateString('pt-BR')}`
          : '',
      ]
        .filter(Boolean)
        .join(', ')
    : '';

  return (
    <div
      className={`rounded-2xl border border-primary/30 bg-primary/5 ${compact ? 'p-3' : 'p-4'}`}
      data-testid="push-granted"
    >
      <div className="flex items-start justify-between gap-3">
        <div className="flex min-w-0 gap-3">
          {coupon ? (
            <Gift className="mt-0.5 h-5 w-5 shrink-0 text-primary" aria-hidden />
          ) : (
            <BellRing className="mt-0.5 h-5 w-5 shrink-0 text-primary" aria-hidden />
          )}
          <div className="min-w-0">
            <p className="text-[15px] font-bold text-gray-900">
              {coupon ? 'Avisos ativados. Seu cupom chegou' : 'Avisos ativados'}
            </p>
            {coupon ? (
              <p className="mt-1 text-[13px] text-gray-700" data-testid="push-granted-coupon">
                {coupon.text}. Use o cupom{' '}
                <span className="font-bold tracking-wide text-gray-900 break-all">
                  {coupon.code}
                </span>{' '}
                no próximo pedido: ele já está guardado no carrinho.
                {details ? ` ${details}.` : ''}
              </p>
            ) : (
              <p className="mt-1 text-[13px] text-gray-700">{message}</p>
            )}
          </div>
        </div>
        <button
          type="button"
          aria-label="Fechar"
          className="-m-2 p-2 text-gray-400"
          onClick={onClose}
        >
          <X className="h-4 w-4" />
        </button>
      </div>
    </div>
  );
}
